export class ProductLight {
  constructor(
    technicalId,
    boomerangId,
    boomerangName
  ) {
    this.technicalId = technicalId
    this.boomerangId = boomerangId
    this.boomerangName = boomerangName
  }
}
